import { useState, useEffect } from "react";
import * as api from "middlewares/apis";
import { useDispatch } from "react-redux";
import { fetchingDataFromApi } from "actions/loaders";

const useAssetTransactions = (assetID, accountID, pageNum, limit, algoChain) => {
	const dispatch = useDispatch();

	const [transactions, setTransactions] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [hasMore, setHasMore] = useState(false);
	const [error, setError] = useState(false);

	useEffect(() => {
		setTransactions([]);
	}, []);

	useEffect(() => {
		getAssetTransactionsByID();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [assetID, accountID, pageNum, limit, algoChain]);

	const getAssetTransactionsByID = async () => {
		dispatch(fetchingDataFromApi(true));

		try {
			setIsLoading(true);
			setError(false);

			const { data } = await api.getAssetTransactionsByID(assetID, accountID, pageNum, limit, algoChain);

			if (data?.data) {
				setTransactions((prev) => {
					return [...new Set([...prev, ...data?.data?.transactions.map((transaction) => transaction)])];
				});

				setHasMore(data?.data?.transactions.length > 0);
				setIsLoading(false);
			} else {
				setHasMore(0);
				setIsLoading(false);
			}
		} catch (error) {
			console.error(error);
		}

		dispatch(fetchingDataFromApi(false));
	};

	const refreshTransactions = () => {
		setTransactions([]);
		setIsLoading(null);
		setHasMore(false);
		setError(false);

		getAssetTransactionsByID();
	};

	return { isLoading, error, transactions, hasMore, refreshTransactions };
};

export default useAssetTransactions;

// const CancelToken = axios.CancelToken;
// let cancel;

// axios
// 	.get(`https://openlibrary.org/search.json?q=${assetID}&page=${pageNum}`, {
// 		cancelToken: new CancelToken((c) => (cancel = c)),
// 	})
// 	.then((res) => {
// 		setTransactions((prev) => {
// 			return [...new Set([...prev, ...res.data.docs.map((d) => d.title)])];
// 		});
// 		setHasMore(res.data.docs.length > 0);
// 		setIsLoading(false);
// 	})
// 	.catch((err) => {
// 		if (axios.isCancel(err)) return;
// 		setError(err);
// 	});

// return () => cancel();
